export default {
  SET_QUESTIONS(state, questions) {
    state.listItems = questions;
  },

  DELETE_LIST_ITEM(state, { parentId, elementId }) {
    if (parentId) {
      const question = state.listItems.find(q => q.id === parentId);
      if (question) {
        question.gmb_answers = question.gmb_answers.filter(
          answer => answer.id !== elementId
        );
      }
    } else {
      state.listItems = state.listItems.filter(question => {
        const hasMatchingAnswer = question.gmb_answers.some(
          answer => answer.id === elementId
        );
        return question.id !== elementId && !hasMatchingAnswer;
      });
    }
  },
  SET_TOTAL_COUNT(state, totalCount) {
    state.totalCount = totalCount;
  }
};
